import { useTheme } from '@mui/material';
import { getPhysicalPixel } from '../../services/utils';

const DRAWER_WIDTH = 300;

export default function useContentWidth(inPhysicalPixel = false) {
  const theme = useTheme();

  let contentWidth = Math.min(window.document.body.clientWidth, theme.breakpoints.values.lg);
  if (contentWidth > theme.breakpoints.values.md) {
    contentWidth -= DRAWER_WIDTH;
  }

  if (inPhysicalPixel) {
    return getPhysicalPixel(contentWidth);
  }

  return contentWidth;
}
